/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ParsedEsaInfoModel } from '../models/ParsedEsaInfoModel';
import type { ParsedPrintersDto } from '../models/ParsedPrintersDto';
import type { ParsedRecallInfoModel } from '../models/ParsedRecallInfoModel';
import type { ParsedServiceBoxModel } from '../models/ParsedServiceBoxModel';
import type { ParsedTechCaseResponseModel } from '../models/ParsedTechCaseResponseModel';
import type { VehicleEsaModel } from '../models/VehicleEsaModel';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class WebScrapingService {

  /**
   * Attempt to auth
   * @returns any Success
   * @throws ApiError
   */
  public static getWebScrapingSaveTableData(): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/WebScraping/SaveTableData',
    });
  }

  /**
   * @returns any Success
   * @throws ApiError
   */
  public static getWebScrapingUpdateBons(): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/WebScraping/UpdateBons',
    });
  }

  /**
   * @param partNo 
   * @returns ParsedServiceBoxModel Success
   * @throws ApiError
   */
  public static getWebScrapingGetPartInfoFromServiceBox(
partNo?: string,
): CancelablePromise<ParsedServiceBoxModel> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/WebScraping/GetPartInfoFromServiceBox',
      query: {
        'partNo': partNo,
      },
    });
  }

  /**
   * @param vin 
   * @returns ParsedRecallInfoModel Success
   * @throws ApiError
   */
  public static getWebScrapingGetRecallInfo(
vin?: string,
): CancelablePromise<Array<ParsedRecallInfoModel>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/WebScraping/get-recall-info',
      query: {
        'vin': vin,
      },
    });
  }

  /**
   * @param vin 
   * @returns ParsedEsaInfoModel Success
   * @throws ApiError
   */
  public static getWebScrapingGetEsaInfo(
vin?: string,
): CancelablePromise<Array<ParsedEsaInfoModel>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/WebScraping/get-esa-info',
      query: {
        'vin': vin,
      },
    });
  }

  /**
   * @param regNo 
   * @param userId 
   * @param isForced 
   * @returns VehicleEsaModel Success
   * @throws ApiError
   */
  public static getWebScrapingGetEsaInfoForced(
    regNo?: string,
    userId?: number,
    isForced?: boolean,
  ): CancelablePromise<VehicleEsaModel> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/WebScraping/get-esa-info-forced',
      query: {
        'regNo': regNo,
        'userId': userId,
        'isForced': isForced,
      },
    });
  }

  /**
   * @param userId 
   * @param driverLicenceNum 
   * @param nationalInsuranceNum 
   * @param postCode 
   * @returns string Success
   * @throws ApiError
   */
  public static getWebScrapingGetDriverInfo(
userId: number,
driverLicenceNum: string,
nationalInsuranceNum: string,
postCode: string,
): CancelablePromise<string> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/WebScraping/get-driver-info',
      query: {
        'UserId': userId,
        'DriverLicenceNum': driverLicenceNum,
        'NationalInsuranceNum': nationalInsuranceNum,
        'PostCode': postCode,
      },
    });
  }

  /**
   * @returns ParsedEsaInfoModel Success
   * @throws ApiError
   */
  public static getWebScrapingGetDriversInfo(): CancelablePromise<Array<ParsedEsaInfoModel>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/WebScraping/get-drivers-info',
    });
  }

  /**
   * @returns ParsedPrintersDto Success
   * @throws ApiError
   */
  public static getWebScrapingGetBranchesPrintersStatus(): CancelablePromise<Array<ParsedPrintersDto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/WebScraping/get-branches-printers-status',
    });
  }


  /**
   * @param vin 
   * @param wipNo 
   * @param branchId 
   * @param id 
   * @returns ParsedTechCaseResponseModel Success
   * @throws ApiError
   */
  public static getWebScrapingJobGetTechCase(
vin?: string,
wipNo?: number,
branchId?: number,
id?: number,
): CancelablePromise<ParsedTechCaseResponseModel> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/WebScraping/job-get-tech-case',
      query: {
        'vin': vin,
        'wipNo': wipNo,
        'branchId': branchId,
        'id': id,
      },
    });
  }

}
